import { useCallback, useMemo, useState } from 'react'
import { useMutation, useQuery, useQueryClient } from 'react-query'

import { getCampaignsAPI, postCreateVouchersAPI } from "api/campaign-voucher";
import { VoucherCreateFormTypes } from "schemas/campaign-voucher-schemas";
import { QUERY_KEYS } from "constants/querykeys";
import { toast } from 'react-toastify';
import { DropDownItem } from 'types/components';

export const useCampaignsQuery = () => {
  const queryKey = [QUERY_KEYS.VOUCHER_LIST]
  const queryFn = async () => {
    return await getCampaignsAPI()
  }
  const queryOptions = {
    refetchOnWindowFocus: false,
    queryKey,
    queryFn,
  }
  const query = useQuery(queryOptions)

  const campaignsOptions = query.data
    ? query.data.data.map((item) => ({
      label: item.campaignName,
      value: String(item.campaignId),
    }))
    : []

  return {
    query,
  }
}

export const useCampaignsMutation = () => {
  const { mutateAsync } = useMutation({
    mutationFn: getCampaignsAPI,
    mutationKey: [QUERY_KEYS.REPORT_MERCHANT_SEARCH],
  });

  // const onSearchCampaignsLoader = useCallback(
  //   async (inputValue: string) => {
  //     const data = await mutateAsync()
  //     const options = data.data.map((item) => ({
  //       label: String(item.campaignName),
  //       value: String(item.campaignId),
  //     }))
  //     return options.filter((opt) =>
  //       opt.label.toLowerCase().includes(inputValue.toLowerCase())
  //     )
  //   },
  //   [mutateAsync]
  // )

  const onSearchCampaignsLoader = async (inputValue: string) => {
    const data = await mutateAsync();
    return data.data
      .filter((c) =>
        c.campaignName.toLowerCase().includes(inputValue.toLowerCase())
      )
      .map((c) => ({
        label: c.campaignName,
        value: String(c.campaignId),
      }));
  };

  return {
    onSearchCampaignsLoader,
  }
}

export const useCampaignsSelectQuery = () => {
  const { query } = useCampaignsQuery()

  const campaignOptions = useMemo(() => {
    const data = query.data?.data || []
    return data.map((item) => ({
      label: item.campaignName,
      value: String(item.campaignId),
    }))
  }, [query.data])

  return { campaignOptions }
}

export const useVoucherCreate = () => {
  const queryClient = useQueryClient();

  const mutationFn = (mutationData: { formData: VoucherCreateFormTypes }) => {
    const { formData } = mutationData;
    return postCreateVouchersAPI(formData);
  };

  const mutation = useMutation({
    mutationFn,
    onError: (error: string) => {
      const message = JSON.parse(JSON.stringify(error))
      toast.error(`${message.outcomeUserMessage || 'Failed to create voucher.'}`)
    },
    onSuccess: async () => {
      await queryClient.invalidateQueries({
        predicate: (query) => query.queryKey[0] === QUERY_KEYS.VOUCHER_LIST
      })
    },
  });

  return mutation;
};
